import type { CardSettings } from 'models/offer';

export const isCardValid = (
  scheme: string,
  type: string,
  cardSettings?: CardSettings,
) => {
  if (!cardSettings) {
    return true;
  }
  return (
    cardSettings?.acceptedCards.includes(scheme.toLocaleUpperCase()) &&
    cardSettings?.cardType.includes(type.toLocaleUpperCase())
  );
};
